import { useEffect, useContext } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export function useNavigationBlocker(shouldBlockFn, onBlockedNavigation) {
  const navigator = useContext(UNSAFE_NavigationContext).navigator;

  useEffect(() => {
    const originalPush = navigator.push;

    navigator.push = (...args) => {
      const nextUrl = args[0]; 
      // ✅ Evaluate dynamically — always the latest value
      if (shouldBlockFn()) {
        onBlockedNavigation(nextUrl);
      } else {
        originalPush(...args);
      }
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [shouldBlockFn, navigator, onBlockedNavigation]);
}
